import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
const firebaseConfig = {
  apiKey: "AIzaSyAyNsxbpXHAZjElUCsGK7XJDxXa9iZSRKQ",
  authDomain: "bihamta-horma.firebaseapp.com",
  databaseURL: "https://bihamta-horma.firebaseio.com",
  projectId: "bihamta-horma",
  storageBucket: "bihamta-horma.appspot.com",
  messagingSenderId: "556975096766",
  appId: "1:556975096766:web:a2567562a773b4d5092fef"
};

const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);

export const getfirebaseToken = (serverURL,setTokenFound) => {
    return getToken(messaging,{vapidKey: 'BPjo00JmJd3iJDCDBSVqcANwLtFSC5K_doe2DaiLEbyG8_2QmF15ZcGZU0ccpEauzldL8GRJVQyO0TPN3YM__Ek'}).then((currentToken) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        fetch(serverURL + "ActiveDeviceAPI/SaveCustomerDeviceToken?firebaseToken=" + currentToken, {
          headers: {
            "Token": localStorage.getItem('token')
          }
        });
        
      } else {
        console.log('No registration token available. Request permission to generate one.');
        if(setTokenFound)
        {
          setTokenFound(false);
        }
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
  }
